import React from "react";
import { LifeBuoy } from "lucide-react";

export const CrisisBar = () => (
  <div data-testid="crisis-bar" className="bg-afwn-navy text-white/80 text-xs sm:text-[13px]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-9 flex items-center justify-center gap-2 text-center">
      <LifeBuoy size={14} className="text-afwn-amber shrink-0" aria-hidden />
      <span>In crisis?</span>
      <a href="tel:988" data-testid="crisis-call-link" className="font-semibold text-white underline decoration-afwn-amber/70 underline-offset-2 hover:text-afwn-amber transition-colors">Call or text 988</a>
      <span className="hidden sm:inline">— free, confidential, 24/7 (US).</span>
      <a href="https://988lifeline.org" target="_blank" rel="noopener noreferrer" data-testid="crisis-lifeline-link" className="hidden md:inline text-white/60 hover:text-white transition-colors">988lifeline.org</a>
    </div>
  </div>
);
